"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Board_vue_1 = require("@/client/components/Board.vue");
const Card_vue_1 = require("@/client/components/card/Card.vue");
const Milestones_vue_1 = require("@/client/components/Milestones.vue");
const Awards_vue_1 = require("@/client/components/Awards.vue");
const PlayersOverview_vue_1 = require("@/client/components/overview/PlayersOverview.vue");
const WaitingFor_vue_1 = require("@/client/components/WaitingFor.vue");
const Sidebar_vue_1 = require("@/client/components/Sidebar.vue");
const Colony_vue_1 = require("@/client/components/colonies/Colony.vue");
const LogPanel_vue_1 = require("@/client/components/logpanel/LogPanel.vue");
const Turmoil_vue_1 = require("@/client/components/turmoil/Turmoil.vue");
const PlanetaryTracks_vue_1 = require("@/client/components/pathfinders/PlanetaryTracks.vue");
const DynamicTitle_vue_1 = require("@/client/components/common/DynamicTitle.vue");
const SortableCards_vue_1 = require("@/client/components/SortableCards.vue");
const TopBar_vue_1 = require("@/client/components/TopBar.vue");
const MoonBoard_vue_1 = require("@/client/components/moon/MoonBoard.vue");
const StackedCards_vue_1 = require("@/client/components/StackedCards.vue");
const PurgeWarning_vue_1 = require("@/client/components/common/PurgeWarning.vue");
const UndergroundTokens_vue_1 = require("@/client/components/underworld/UndergroundTokens.vue");
const KeyboardShortcuts_vue_1 = require("@/client/components/KeyboardShortcuts.vue");
const utils_1 = require("@/common/utils/utils");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const KeyboardNavigation_1 = require("@/client/components/KeyboardNavigation");
const Phase_1 = require("@/common/Phase");
const CardType_1 = require("@/common/cards/CardType");
const TileView_1 = require("./board/TileView");
const CardUtils_1 = require("@/client/utils/CardUtils");
const ActiveCardsSortingOrder_1 = require("@/client/utils/ActiveCardsSortingOrder");
const ClientCardManifest_1 = require("../cards/ClientCardManifest");
class TerraformedAlertDialog {
}
TerraformedAlertDialog.shouldAlert = true;
exports.default = vue_1.default.extend({
    name: 'player-home',
    data() {
        const preferences = (0, PreferencesManager_1.getPreferences)();
        return {
            showHand: !preferences.hide_hand,
            showActiveCards: !preferences.hide_active_cards,
            showAutomatedCards: !preferences.hide_automated_cards,
            showEventCards: !preferences.hide_event_cards,
            tileView: 'show',
            keyboardShortcutOpened: false,
            hotkeyTargets: [],
        };
    },
    watch: {
        showHand: function hide_hand() {
            PreferencesManager_1.PreferencesManager.INSTANCE.set('hide_hand', !this.showHand);
        },
        showActiveCards: function toggle_active_cards() {
            PreferencesManager_1.PreferencesManager.INSTANCE.set('hide_active_cards', !this.showActiveCards);
        },
        showAutomatedCards: function toggle_automated_cards() {
            PreferencesManager_1.PreferencesManager.INSTANCE.set('hide_automated_cards', !this.showAutomatedCards);
        },
        showEventCards: function toggle_event_cards() {
            PreferencesManager_1.PreferencesManager.INSTANCE.set('hide_event_cards', !this.showEventCards);
        },
    },
    props: {
        playerView: {
            type: Object,
        },
        settings: {
            type: Object,
        },
    },
    computed: {
        thisPlayer() {
            return this.playerView.thisPlayer;
        },
        game() {
            return this.playerView.game;
        },
        CardType() {
            return CardType_1.CardType;
        },
        cardsInHandCount() {
            const playerView = this.playerView;
            return playerView.cardsInHand.length + playerView.preludeCardsInHand.length + playerView.ceoCardsInHand.length;
        },
        getCardsByType() {
            return CardUtils_1.getCardsByType;
        },
        isCardActivated() {
            return CardUtils_1.isCardActivated;
        },
        sortActiveCards() {
            return ActiveCardsSortingOrder_1.sortActiveCards;
        },
    },
    components: {
        'board': Board_vue_1.default,
        DynamicTitle: DynamicTitle_vue_1.default,
        Card: Card_vue_1.default,
        'players-overview': PlayersOverview_vue_1.default,
        'waiting-for': WaitingFor_vue_1.default,
        Milestones: Milestones_vue_1.default,
        Awards: Awards_vue_1.default,
        'sidebar': Sidebar_vue_1.default,
        'colony': Colony_vue_1.default,
        'log-panel': LogPanel_vue_1.default,
        'turmoil': Turmoil_vue_1.default,
        'sortable-cards': SortableCards_vue_1.default,
        'top-bar': TopBar_vue_1.default,
        MoonBoard: MoonBoard_vue_1.default,
        PlanetaryTracks: PlanetaryTracks_vue_1.default,
        'stacked-cards': StackedCards_vue_1.default,
        PurgeWarning: PurgeWarning_vue_1.default,
        UndergroundTokens: UndergroundTokens_vue_1.default,
        KeyboardShortcuts: KeyboardShortcuts_vue_1.default,
    },
    methods: {
        navigatePage(event) {
            if (event.key === '?') {
                this.keyboardShortcutOpened = !this.keyboardShortcutOpened;
                return;
            }
            if (event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
                return;
            }
            const ids = {
                [KeyboardNavigation_1.KeyboardNavigation.GAMEBOARD]: 'shortkey-board',
                [KeyboardNavigation_1.KeyboardNavigation.PLAYERSOVERVIEW]: 'shortkey-playersoverview',
                [KeyboardNavigation_1.KeyboardNavigation.HAND]: 'shortkey-hand',
                [KeyboardNavigation_1.KeyboardNavigation.COLONIES]: 'shortkey-colonies',
            };
            const inputSource = event.target;
            console.log(inputSource.nodeName);
            if (inputSource.nodeName.toLowerCase() !== 'input') {
                const id = ids[event.code];
                if (id) {
                    const el = document.getElementById(id);
                    if (el) {
                        event.preventDefault();
                        el.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
                    }
                }
                else if (event.code.startsWith('Digit')) {
                    const ASCII_ONE = '1'.charCodeAt(0);
                    const index = event.code.charCodeAt(5) - ASCII_ONE;
                    if (index >= 0 && index < this.hotkeyTargets.length) {
                        const el = this.hotkeyTargets[index];
                        console.log(el);
                        if (el) {
                            el.scrollIntoView({ block: 'start', inline: 'center', behavior: 'smooth' });
                        }
                    }
                }
            }
        },
        isPlayerActing(playerView) {
            return playerView.players.length > 1 && playerView.waitingFor !== undefined;
        },
        getPlayerCssForTurnOrder: (player, highlightActive) => {
            const classes = ['highlighter_box'];
            if (highlightActive) {
                if (player.needsToDraft || (player.needsToDraft === undefined && player.isActive)) {
                    classes.push('player_is_active');
                }
                classes.push((0, utils_1.playerColorClass)(player.color, 'bg'));
            }
            return classes.join(' ');
        },
        getFleetsCountRange(player) {
            const fleetsRange = [];
            for (let i = 0; i < player.fleetSize - player.tradesThisGeneration; i++) {
                fleetsRange.push(i);
            }
            return fleetsRange;
        },
        toggle(type) {
            switch (type) {
                case 'HAND':
                    this.showHand = !this.showHand;
                    break;
                case 'ACTIVE':
                    this.showActiveCards = !this.showActiveCards;
                    break;
                case 'AUTOMATED':
                    this.showAutomatedCards = !this.showAutomatedCards;
                    break;
                case 'EVENT':
                    this.showEventCards = !this.showEventCards;
                    break;
            }
        },
        cycleTileView() {
            this.tileView = (0, TileView_1.nextTileView)(this.tileView);
        },
        isVisible(type) {
            switch (type) {
                case 'HAND':
                    return this.showHand;
                case 'ACTIVE':
                    return this.showActiveCards;
                case 'AUTOMATED':
                    return this.showAutomatedCards;
                case 'EVENT':
                    return this.showEventCards;
            }
            return false;
        },
        isInitialDraftingPhase() {
            return (this.game.phase === Phase_1.Phase.INITIALDRAFTING) && this.game.gameOptions.initialDraftVariant;
        },
        getToggleLabel(hideType) {
            if (hideType === 'HAND') {
                return (this.showHand ? '✔' : '');
            }
            else if (hideType === 'ACTIVE') {
                return (this.showActiveCards ? '✔' : '');
            }
            else if (hideType === 'AUTOMATED') {
                return (this.showAutomatedCards ? '✔' : '');
            }
            else if (hideType === 'EVENT') {
                return (this.showEventCards ? '✔' : '');
            }
            else {
                return '';
            }
        },
        getHideButtonClass(hideType) {
            const prefix = 'hiding-card-button ';
            if (hideType === 'HAND') {
                return prefix + (this.showHand ? 'hand-toggle' : 'hand-toggle-transparent');
            }
            else if (hideType === 'ACTIVE') {
                return prefix + (this.showActiveCards ? 'active' : 'active-transparent');
            }
            else if (hideType === 'AUTOMATED') {
                return prefix + (this.showAutomatedCards ? 'automated' : 'automated-transparent');
            }
            else if (hideType === 'EVENT') {
                return prefix + (this.showEventCards ? 'event' : 'event-transparent');
            }
            else {
                return '';
            }
        },
        isActive(cardModel) {
            const card = (0, ClientCardManifest_1.getCardOrThrow)(cardModel.name);
            return card.type === CardType_1.CardType.ACTIVE || card.hasAction;
        },
        isNotActive(cardModel) {
            return !(0, ClientCardManifest_1.getCardOrThrow)(cardModel.name).hasAction;
        },
    },
    destroyed() {
        window.removeEventListener('keydown', this.navigatePage);
    },
    mounted() {
        window.addEventListener('keydown', this.navigatePage);
        if (this.game.isTerraformed && TerraformedAlertDialog.shouldAlert && (0, PreferencesManager_1.getPreferences)().show_alerts) {
            alert('Mars is Terraformed!');
            TerraformedAlertDialog.shouldAlert = false;
        }
        const targets = this.$el.getElementsByClassName('hotkey-target');
        for (let i = 0; i < targets.length; i++) {
            const element = targets.item(i);
            if (element) {
                this.hotkeyTargets.push(element);
            }
        }
    },
});
